<template>
  <div v-editable="blok" class="gallerie">
      <div class="select-wrapper">
        <select v-if="blok.images.length > 0 && this.options.length > 0" v-model="currCategory" @change="changePictures()">
            <option v-for="opt in options" :key="opt">{{opt}}</option>
        </select>
      </div>
      <div class="preview-wrapper">
          <table>
              <tr>
                  <td><div class="left-arrow" @click="deincreaseIdx(-1)"></div></td>
                  <td id="imgtd"><img v-if="pictures.length > 0" :src="pictures[idx]"/></td>
                  <td><div class="right-arrow" @click="deincreaseIdx(+1)"></div></td>
              </tr>
          </table>
      </div>
      <div class="photos-wrapper">
          <component :key="blok._uid" v-for="blok in blok.images" :blok="blok" :is="blok.component" :currentCategory="currCategory" v-on:click.native="updateIdx(blok.image)"></component>
      </div>
  </div>
</template>

<script>
export default {
  props: ['blok'],
  data () {
    return {
        options: [],
        currCategory: '',
        pictures: [],
        idx: 0
    }
  },
  mounted(){
      this.options = this.blok.categories.split(";");
      this.currCategory = this.options[0];
      this.changePictures();
  },
  methods:{
      changePictures(){
          this.pictures = this.blok.images.filter(ele => ele.category == this.currCategory).map(e => e.image);
          console.log(this.pictures)
      },
      updateIdx(img){
          this.idx = this.pictures.indexOf(img);
      },
      deincreaseIdx(val){
          console.log(val);
          if(this.idx + val < 0){
              this.idx = this.pictures.length-1;
          }
          else if((this.idx + val) > this.pictures.length-1){
              this.idx = 0;
          }
          else{
              this.idx += val;
          }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gallerie.vue